import { sendFetch, sendInfoManagerFetch, POST_OPTIONS, GET_OPTIONS, sendSellerFetch } from './base.service';
import { getCompany, getUserId } from '../_utils/storage_handler';
import { buildTimeStampString } from '../_utils/date_format.utils';

const BASE_PATH_INFO = '/departures';
const BASE_PATH = '/departures';
const OD_PATH = '/orders-detail';

export const uploadDeparturesData = async (bytes, extension, type, date_created) => {
    let body = {
        bytes,
        extension,
        type,
        company: getCompany(),
        date_created: buildTimeStampString(date_created ? date_created : new Date())
    }
    return await sendInfoManagerFetch(`${BASE_PATH_INFO}`, POST_OPTIONS, body);
}

export const findAllDepartures = async () => {
    return await sendFetch(`${BASE_PATH}/all/${getCompany()}`, GET_OPTIONS);
}

export const findAllDateGroupDepartures = async () => {
    return await sendFetch(`${BASE_PATH}/all-date-group/company/${getCompany()}`, GET_OPTIONS);
}

export const findAllDateGroupClientDepartures = async (client) => {
    return await sendFetch(`${BASE_PATH}/all-date-group/client/company/${client}/${getCompany()}`, GET_OPTIONS);
}

export const findClientDepartures = async (client_cod) => {
    return await sendSellerFetch(`${BASE_PATH}/all/client/${getCompany()}/${client_cod}`, GET_OPTIONS);
}

export const despathDateOrdersClientByMonthAndYear = async (month, year) => {
    return await sendFetch(`${OD_PATH}/despath/month/year/${month}/${year}`, GET_OPTIONS);
}

export const despathDateOrdersClientBySellerMonthAndYear = async (month, year) => {
    return await sendSellerFetch(`${OD_PATH}/despath/month/year/seller/${month}/${year}/${getUserId()}`, GET_OPTIONS);
}

export const excelDespathDateOrdersClientByMonthAndYear = async (month, year) => {
    return await sendSellerFetch(`${OD_PATH}/excel/despath/month/year/${month}/${year}`, GET_OPTIONS);
}

export const excelDespathDateOrdersClientBySellerMonthAndYear = async (month, year) => {
    return await sendSellerFetch(`${OD_PATH}/excel/despath/month/year/seller/${month}/${year}/${getUserId()}`, GET_OPTIONS);
}

export const despathDateOrdersGroupByClientAndDate = async (date, client) => {
    return await sendSellerFetch(`${OD_PATH}/despath/date/client/${date}/${client}`, GET_OPTIONS);
}